import boats1 from "./full/20260623_164354.webp";
import boats2 from "./full/20260623_164731.webp";
import boats3 from "./full/20260623_170012.webp";
import boats4 from "./full/20260623_170031.webp";
import boats5 from "./full/20260623_170128.webp";
import boats6 from "./full/20260623_170310.webp";
import boats7 from "./full/20260623_170458 (1).webp";
import boats8 from "./full/20260623_170540.webp";
import boats9 from "./full/20260623_171950.webp";
import boats10 from "./full/20260623_172836.webp";
import boats11 from "./full/20260623_174328 (2).webp";
import boats12 from "./full/electric-boats.webp";
import boats1Thumb from "./thumb/20260623_164354 (1).webp";
import boats2Thumb from "./thumb/20260623_164731 (1).webp";
import boats3Thumb from "./thumb/20260623_170012 (1).webp";
import boats4Thumb from "./thumb/20260623_170031 (2).webp";
import boats5Thumb from "./thumb/20260623_170128 (1).webp";
import boats6Thumb from "./thumb/20260623_170310 (1).webp";
import boats7Thumb from "./thumb/20260623_170458.webp";
import boats8Thumb from "./thumb/20260623_170540 (1).webp";
import boats9Thumb from "./thumb/20260623_171950 (1).webp";
import boats10Thumb from "./thumb/20260623_172836 (1).webp";
import boats11Thumb from "./thumb/20260623_174328.webp";
import boats12Thumb from "./thumb/electric-boats (1).webp";

export const boatsImages = [
    { thumb: boats1Thumb, full: boats1, altKey: "1" },
    { thumb: boats2Thumb, full: boats2, altKey: "2" },
    { thumb: boats3Thumb, full: boats3, altKey: "3" },
    { thumb: boats4Thumb, full: boats4, altKey: "4" },
    { thumb: boats5Thumb, full: boats5, altKey: "5" },
    { thumb: boats6Thumb, full: boats6, altKey: "6" },
    { thumb: boats7Thumb, full: boats7, altKey: "7" },
    { thumb: boats8Thumb, full: boats8, altKey: "8" },
    { thumb: boats9Thumb, full: boats9, altKey: "9" },
    { thumb: boats10Thumb, full: boats10, altKey: "10" },
    { thumb: boats11Thumb, full: boats11, altKey: "11" },
    { thumb: boats12Thumb, full: boats12, altKey: "12" }
];